export const ANALYSIS_FUNCTIONS = [
    { key: 'transcript_summary', title: 'Sintesi' },
    { key: 'case_formulation', title: 'Analisi per orientamento'/*, description: 'Quadro sintetico del caso.' */ }
];

export const EXTRA_FUNCTIONS = [];
